import { Button, Card, Empty, Flex } from "antd"
import React from "react"

import type { Lead } from "../../../Lead/types/lead.types.ts"
import { LeadsApprovalMobileCard } from "./LeadsApprovalMobileCard"

interface LeadApprovalMobileProps {
  leads: Lead[]
  loading: boolean
  saving: boolean
  hasMore: boolean
  onLoadMore: () => void
  onActionClick: (lead: Lead, active: string) => void
}

export default function LeadApprovalMobile({
  leads,
  loading,
  saving,
  hasMore,
  onLoadMore,
  onActionClick
}: LeadApprovalMobileProps) {
  const initialLoading = loading && leads.length === 0

  return (
    <Flex vertical gap="middle">
      {leads?.length ? (
        leads?.map((lead) => (
          <LeadsApprovalMobileCard
            key={lead?.id}
            lead={lead}
            onActionClick={onActionClick}
            loading={initialLoading}
            saving={saving}
          />
        ))
      ) : (
        <Card loading={initialLoading}>
          <Empty />
        </Card>
      )}
      {hasMore && (
        <Button block loading={loading} onClick={onLoadMore}>
          Load more
        </Button>
      )}
    </Flex>
  )
}
